import React, { useState, useCallback } from 'react';
import { DialogFullScreen, useDialog, Carousel, useCarousel } from '@yuhu-inc/yuhui';

import { AddTemplateTypePage } from './AddTemplateTypePage';
import { AddTemplatePropertyPage } from './AddTemplatePropertyPage';
import { AddTemplateUnitTypePage } from './AddTemplateUnitTypePage';
import { AddTemplateNamePage } from './AddTemplateNamePage';

export const AddTemplateDialog = ({
  handleCreateOrUpdateTemplate,
  upsertingTemplate,
  children,
}) => {
  const dialog = useDialog();

  return (
    <>
      <DialogFullScreen hideOnClickOutside={false} label="Add Template" {...dialog}>
        <AddTemplateCarousel
          handleCreateOrUpdateTemplate={handleCreateOrUpdateTemplate}
          upsertingTemplate={upsertingTemplate}
          closeDialog={dialog.hide}
        />
      </DialogFullScreen>
      {children(dialog)}
    </>
  );
};

export const TEMPLATE_TYPE_PAGE = 0;
export const TEMPLATE_PROPERTY_PAGE = 1;
export const TEMPLATE_UNIT_TYPE_PAGE = 2;
export const TEMPLATE_NAME_PAGE = 3;

const AddTemplateCarousel = ({ handleCreateOrUpdateTemplate, upsertingTemplate, closeDialog }) => {
  const { pageIndex, goTo, back, forward, ...rest } = useCarousel({
    numOfPages: 4,
  });
  const [template, setTemplate] = useState({});
  const handleCreateTemplate = useCallback(
    (formValue) => {
      return handleCreateOrUpdateTemplate({ ...template, ...formValue });
    },
    [handleCreateOrUpdateTemplate, template]
  );

  return (
    <Carousel
      pageIndex={pageIndex}
      {...rest}
      pages={[
        <AddTemplateTypePage goTo={goTo} setTemplate={setTemplate} />,
        <AddTemplatePropertyPage goTo={goTo} setTemplate={setTemplate} />,
        <AddTemplateUnitTypePage forward={forward} setTemplate={setTemplate} />,
        <AddTemplateNamePage
          closeDialog={closeDialog}
          handleCreateTemplate={handleCreateTemplate}
          upsertingTemplate={upsertingTemplate}
        />,
      ]}
    />
  );
};
